<template>
  <svg viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 0H3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3zm-.3 4.8l-8 7c-.218.112-.456.18-.7.2a1.854 1.854 0 0 1-.7-.2l-8-7a.992.992 0 0 1 1.3-1.5l7.3 6.4 7.3-6.4a.972.972 0 0 1 1.4.1.9.9 0 0 1 .1 1.4z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
